import { useNavigate } from 'react-router-dom';
import logoMobile from '../../assets/logo-mobile.svg';
import { NotificationIcon, MenuIcon, CloseIcon } from '@pro-sto/ui';
import { ROUTES } from '../../constants/routes';
import './MobileHeader.css';

interface MobileHeaderProps {
  onMenuClick: () => void;
  onNotificationClick?: () => void;
  isMenuOpen?: boolean;
}

export const MobileHeader = ({ onMenuClick, onNotificationClick, isMenuOpen = false }: MobileHeaderProps) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(ROUTES.ORDERS);
  };

  return (
    <header className="mobile-header" data-testid="mobile-header">
      <img 
        src={logoMobile} 
        alt="просто" 
        className="mobile-header__logo" 
        onClick={handleLogoClick}
        data-testid="mobile-header-logo"
      />
      
      <div className="mobile-header__buttons">
        {!isMenuOpen && (
          <button 
            className="mobile-header__button" 
            onClick={onNotificationClick}
            aria-label="Уведомления"
            data-testid="mobile-header-notifications"
          >
            <NotificationIcon />
          </button>
        )}
        
        <button 
          className="mobile-header__button" 
          onClick={onMenuClick}
          aria-label={isMenuOpen ? "Закрыть меню" : "Меню"}
          data-testid="mobile-header-menu"
        >
          {isMenuOpen ? <CloseIcon /> : <MenuIcon />}
        </button>
      </div>
    </header>
  );
};
